module.exports = __webpack_public_path__ + "estadodecuenta.png?b859e8edb0f27c046bdd5899a8cac092";


//////////////////
// WEBPACK FOOTER
// ./src/assets/estadodecuenta.png
// module id = 674
// module chunks = 0 2 7 8 9 10